import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useUnit } from "effector-react";
import { Vehicle } from "../../../../types/vehicles.types";
import { CustomersStore } from "../../../../stores/CustomersStore/CustomersStore";
import { FleetsStore } from "../../../../stores/FleetsStore/FleetsStore";
import { ActionsCell } from "../../../../components/Table";
import DeleteVehicle from "../DeleteVehicle/DeleteVehicle";
import EditVehicle from "../EditVehicle/EditVehicle";

interface Props {
  vehicle: Vehicle;
}

function formatPlate(raw: string): string {
  const v = (raw ?? "").replace(/[^A-Z0-9]/gi, "").toUpperCase().substring(0, 7);
  if (v.length <= 3) return v;
  return `${v.substring(0, 3)}-${v.substring(3)}`;
}

const VehicleRow: React.FC<Props> = ({ vehicle }) => {
  const { customers } = useUnit(CustomersStore);
  const { fleets } = useUnit(FleetsStore);

  const clientName = customers.find((c) => c.id === vehicle.clientId)?.name ?? "—";
  const fleetDescription = vehicle.fleetId
    ? (fleets.find((f) => f.id === vehicle.fleetId)?.description ?? "—")
    : "—";

  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }} hover>
      <TableCell component="th" scope="row" sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
        {formatPlate(vehicle.licencePlate)}
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>{clientName}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>{fleetDescription}</TableCell>
      <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
        <ActionsCell style={{ justifyContent: "flex-end" }}>
          <DeleteVehicle vehicle={vehicle} />
          <EditVehicle vehicle={vehicle} />
        </ActionsCell>
      </TableCell>
    </TableRow>
  );
};

export default VehicleRow;
